module.exports = __webpack_public_path__ + "static/media/Asset_Management.cb973f29.png";